import dayjs from 'dayjs';

import type { HealthService, HealthStatus, MatchStatus, TeamInfo } from './types';

export function toNumber(value?: number | string | null) {
  const num = Number(value ?? 0);

  return Number.isFinite(num) ? num : 0;
}

export function formatInt(value?: number | string | null) {
  return new Intl.NumberFormat('en-US').format(toNumber(value));
}

export function formatCompact(value?: number | string | null) {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(toNumber(value));
}

export function formatUsdShort(value?: number | string | null) {
  return `$${formatCompact(value)}`;
}

export function formatSignedInt(value?: number | string | null, suffix = '') {
  const num = toNumber(value);
  const sign = num > 0 ? '+' : '';

  return `${sign}${formatInt(num)}${suffix}`;
}

export function formatSignedUsd(value?: number | string | null, suffix = '') {
  const num = toNumber(value);
  const sign = num > 0 ? '+' : '';

  return `${sign}${formatUsdShort(num)}${suffix}`;
}

export function formatTime(value?: string | null) {
  if (!value) return '--';

  return dayjs(value).format('YYYY-MM-DD HH:mm');
}

export function getTeamName(team?: TeamInfo | null, locale?: string) {
  if (!team) return '--';

  if (locale === 'zh' || locale === 'cn') {
    return team.nameZh || team.nameEn || team.code || '--';
  }
  return team.nameEn || team.nameZh || team.code || '--';
}

export function getMatchStatusKey(status?: MatchStatus) {
  if (!status) return 'unknown';

  return status;
}

export function getHealthStatusKey(status?: HealthStatus) {
  if (!status) return 'unknown';

  return status;
}

export function getHealthColor(status: HealthStatus) {
  const map: Record<HealthStatus, string> = {
    healthy: '#22c55e',
    degraded: '#f59e0b',
    down: '#ef4444',
  };

  return map[status] ?? '#94a3b8';
}

export function getServiceI18nKey(service: HealthService) {
  const map: Record<HealthService, string> = {
    match_feed: 'worldCup.overview.health.services.matchFeed',
    config: 'worldCup.overview.health.services.config',
    settlement: 'worldCup.overview.health.services.settlement',
    treasury: 'worldCup.overview.health.services.treasury',
  };

  return map[service] ?? service;
}
